import { useCallback } from 'react';
import _debounce from 'lodash/debounce';
import { Map as MapboxMap } from 'mapbox-gl';

const MAP_RESIZE_DEBOUNCE_DELAY = 100;

const useMapResize = (map: MapboxMap) => {
	const mapResize = useCallback(() => {
		if (!map) {
			return;
		}
		map.getCanvasContainer().style.width = '100%';
		map.resize();
	}, [map]);

	const debouncedResize = _debounce(mapResize, MAP_RESIZE_DEBOUNCE_DELAY);

	const resizeObserver = new ResizeObserver(debouncedResize);

	const resizedContainerRef = useCallback(
		(container: HTMLDivElement) => {
			if (container !== null) {
				resizeObserver.observe(container);
			} else {
				if (resizeObserver) resizeObserver.disconnect();
			}
		},
		[resizeObserver]
	);

	return { resizedContainerRef };
};

export default useMapResize;
